var React = require('react');

function PaperPlane (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M245.53 410.5l-75 92.83c-14 17.1-42.5 7.8-42.5-15.8V358l280.26-252.77c5.5-4.9 13.3 2.6 8.6 8.3L191.72 387.87z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M511.59 28l-72 432a24.07 24.07 0 0 1-33 18.2l-214.87-90.33 225.17-274.34c4.7-5.7-3.1-13.2-8.6-8.3L128 358 14.69 313.83a24 24 0 0 1-2.2-43.2L476 3.23c17.29-10 39 4.6 35.59 24.77z","className":"fa-primary","key":2})]);
}

PaperPlane.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = PaperPlane;

PaperPlane.default = PaperPlane;
